import { memo } from 'react';
import { Box } from '@betty/moonlight';
import { AmountContainerProps } from './AmountContainer.types';

function AmountContainer({
  selected,
  children,
  ...rest
}: AmountContainerProps) {
  return (
    <Box
      flex={1}
      height="space-1400"
      borderRadius="radius-200"
      centerContent
      {...rest}
      {...(selected
        ? { variant: 'gradient', gradient: 'accentBackground' }
        : { variant: 'default', backgroundColor: 'primaryBackground' })}
    >
      {children}
    </Box>
  );
}

export default memo(AmountContainer);
